// FILE: client/src/screens/BespokeScreen.js
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import Message from "../../components/Message";
import Meta from "../../components/Meta";
import { listPortfolio } from "../../actions/portfolioActions";
import PortfolioMagazine from "../../components/portfolio/PortfolioMagazine";

export default function BespokeScreen() {
  const dispatch = useDispatch();

  const portfolioList = useSelector((state) => state.portfolioList);
  const { loading, error, items = [] } = portfolioList;

  useEffect(() => {
    dispatch(listPortfolio("bespoke"));
  }, [dispatch]);

  return (
    <>
      <Meta
        title="Bespoke Tailoring London | Academy Costumes London"
        description="Academy Costumes London offers bespoke tailoring in London for period and contemporary costume, theatre, film and private commissions."
        image="/images/home/bespoke-tailoring.jpg"
        url="/bespoke"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Bespoke Tailoring", url: "/bespoke" },
        ]}
      />

      <Container as="main" fluid className="p-0">
        {loading ? (
          <div className="p-4">
            <Loader />
          </div>
        ) : error ? (
          <div className="p-4">
            <Message variant="danger">{error}</Message>
          </div>
        ) : items.length === 0 ? (
          <div className="p-4">
            <Message>No bespoke slides yet.</Message>
          </div>
        ) : (
          <PortfolioMagazine items={items} />
        )}
      </Container>
    </>
  );
}
